<template>
  <div id="TemplateDefault">
    <!-- topo -->
    <MainHeader />

    <!-- menu principal -->

    <!-- conteúdo principal -->
    <section>
      <router-view />
    </section>

    <el-dialog
      :title="`Sua sessão expirou. Para revalidar informe sua senha e clique em entrar`"
      width="400px"
      :visible="getLoginExpired"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <el-form :model="login">
        <el-form-item
          v-if="possuiDadosUsuarioNaStore"
          label="Nome"
        >
          <el-input
            v-model="usuarioNome"
            disabled
            autocomplete="off"
          />
        </el-form-item>
        <div v-else>
          <el-form-item label="CNPJ">
            <el-input
              v-model="login.cnpj"
              v-mask="MASCARA_CNPJ"
            />
          </el-form-item>
          <el-form-item label="CPF">
            <el-input
              v-model="login.cpf"
              v-mask="MASCARA_CPF"
            />
          </el-form-item>
        </div>
        <el-form-item label="Senha">
          <el-input
            @keypress.native.enter="Logar"
            v-model="login.password"
            type="password"
            autocomplete="off"
          />
        </el-form-item>
      </el-form>
      <div style="padding-top:20px;">
        <a
          @click="Logar"
          v-loading="dialog.login.logando"
          class="btn vermelho"
        >Entrar</a>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ou
        <a
          @click="Sair"
          class="btn"
        >Sair do sistema</a>
      </div>
    </el-dialog>

    <el-dialog
      :title="`Meio de pagamento alterado para utilização de agente financeiro. Informe as credenciais de acesso recebidas por e-mail para continuar...`"
      width="370px"
      :visible="dialog.repom.aberto"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <el-alert
        type="warning"
        :closable="false"
        style="word-break: normal;"
      >
        As informações de acesso foram enviadas por e-mail. Em caso de dúvidas, entre em contato com o suporte.
      </el-alert>
      <br>
      <br>
      <el-form :model="repom">
        <el-form-item label="CNPJ - UTILIZADO NA CONTA DO AGENTE FINANCEIRO">
          <el-input
            v-model="repom.cnpj"
            v-mask="MASCARA_CNPJ"
          />
        </el-form-item>
        <el-form-item label="USUÁRIO - ENVIADO POR E-MAIL">
          <el-input v-model="repom.usuario" />
        </el-form-item>
        <el-form-item label="SENHA - ENVIADA POR E-MAIL">
          <el-input
            @keypress.native.enter="ArmazenarCredenciasAcesso"
            v-model="repom.senha"
            type="password"
            show-password
            autocomplete="off"
          />
        </el-form-item>
      </el-form>
      <div style="padding-top:20px;">
        <a
          @click="ArmazenarCredenciasAcesso"
          v-loading="dialog.repom.salvando"
          class="btn vermelho"
        >Armazenar credenciais de acesso</a>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import http from '@/services/axios'
import services from '@/services'
import MainHeader from '../Layout/MainHeader'
import { mapActions, mapGetters } from 'vuex'
import Pusher from 'pusher-js'
import { confirmar, formataNumeroCarga, MASCARA_CNPJ, MASCARA_CPF } from '@/assets/js/helpers'

Pusher.logToConsole = false

export default {
  name: 'TemplateDefault',
  components: {
    MainHeader,
  },
  data() {
    return {
      // TRKM-2740: as mascaras vem do modulo canonico de documento, para que a tela nao
      // reintroduza o formato numerico antigo ao ser alterada.
      MASCARA_CNPJ,
      MASCARA_CPF,
      pusher: null,
      channel: null,
      name: null,
      login: {
        cnpj: null,
        cpf: null,
        password: null,
      },
      repom: {
        cnpj: '02116946000143',
        usuario: '4642',
        senha: 'Repom10Repom10',
      },
      dialog: {
        login: {
          logando: false,
        },
        repom: {
          aberto: false,
          salvando: false,
        },
      }
    }
  },
  computed: {
    ...mapGetters({
      getUsuario: 'getUsuario',
      getFretes: 'getFretes',
      getFrete: 'getFrete',
      getSalas: 'getSalas',
      getLoginExpired: 'getLoginExpired',
    }),
    usuarioNome() {
      return this.getUsuario.nome
    },
    possuiDadosUsuarioNaStore() {
      return this.getUsuario && this.getUsuario.cpf && this.getUsuario.embarcador && this.getUsuario.embarcador[0] && this.getUsuario.embarcador[0].cnpj
    }
  },
  methods: {
    ...mapActions({
      setFretes: 'setFretes',
      setFrete: 'setFrete',
      setTransportadorSelecionado: 'setTransportadorSelecionado',
      setSalas: 'setSalas',
      setSala: 'setSala',
      setUsuario: 'setUsuario',
      setLoginExpired: 'setLoginExpired',
      setContratos: 'setContratos',
    }),
    PusherFabricarInstancia() {
      this.pusher = new Pusher(process.env.PUSHER_KEY, { cluster: 'us2' })
    },
    PusherInscreverCanais() {
      const embarcador = this.getUsuario.embarcador[0]
      const isEmbarcador = embarcador && embarcador.id && embarcador.id !== null

      if (isEmbarcador) {
        this.name = 'embarcador-' + this.getUsuario.embarcador[0].id
        this.channel = this.pusher.subscribe(this.name)

        this.PusherEmbarcadorLigarEventoFreteAtualizado()
      } else {
        this.name = 'truckme'
        this.channel = this.pusher.subscribe(this.name)

        this.PusherAdministradorLigarEventoTransportadorAtualizado()
        this.PusherAdministradorLigarEventoFreteAtualizado()
        this.PusherAdministradorLigarEventoEmbarcadorContraofertou()
        this.PusherAdministradorLigarEventoEmbarcadorSelecionou()
        this.PusherAdministradorLigarEventoTransportadorAprovado()
        this.PusherAdministradorLigarEventoTransportadorReprovado()
        this.PusherAdministradorLigarEventoTransportadorEmAnalise()
      }
    },
    PusherEmbarcadorLigarEventoFreteAtualizado() {
      const vm = this
      this.channel.bind('frete-atualizado', async function ({ embarcadorId, freteId }) {
        const frete = (await services.Operacional.getFrete(embarcadorId, freteId)).data
        if (typeof vm.getFrete.id !== 'undefined' && vm.getFrete.id === freteId) {
          frete.tracking = vm.getFrete.tracking
          vm.setFrete(frete)
        } else {
          let fretes = JSON.parse(JSON.stringify(vm.getFretes))
          fretes.map((f) => {
            if (f.id == freteId) {
              f.status = frete.status
            }

            return f
          })
          vm.setFretes(fretes)
        }
        vm.$bus.$emit('frete-atualizado', freteId)
      })
    },
    PusherAdministradorLigarEventoTransportadorAtualizado() {
      const vm = this
      this.channel.bind('transportador-atualizado', async function (data) {
        const transportadorId = data.id
        const response = await services.Transportadores.listarContratosPorTransportadorId(transportadorId)
        vm.setContratos(response.data)
      })
    },
    PusherAdministradorLigarEventoFreteAtualizado() {
      const vm = this
      this.channel.bind('frete-atualizado', async function (data) {
        const freteId = data.freteId
        vm.$bus.$emit('administrador-frete-atualizado', freteId)
      })
    },
    PusherAdministradorLigarEventoTransportadorAprovado() {
      const vm = this
      this.channel.bind('transportador-aprovado', async function (data) {
        const freteId = data.freteId
        vm.$bus.$emit('transportador-aprovado', freteId)
      })
    },
    PusherAdministradorLigarEventoTransportadorReprovado() {
      const vm = this
      this.channel.bind('transportador-reprovado', async function (data) {
        const freteId = data.freteId
        vm.$bus.$emit('transportador-reprovado', freteId)
      })
    },
    PusherAdministradorLigarEventoTransportadorEmAnalise() {
      const vm = this
      this.channel.bind('transportador-analise', async function (data) {
        const freteId = data.freteId
        vm.$bus.$emit('transportador-analise', freteId)
      })
    },
    PusherAdministradorLigarEventoEmbarcadorContraofertou() {
      const vm = this
      this.channel.bind('embarcador-contraofertou', async function (data) {
        const freteId = data.freteId
        vm.$bus.$emit('embarcador-contraofertou', freteId)
        confirmar(
          `Carga ${formataNumeroCarga(freteId)}`,
          `O embarcador negociou o valor da carga e esta ação requer uma reposta através do módulo Contratação. Deseja responder agora?`,
          async () => {
            vm.$router.push({ name: 'ParceiroContratacaoPorFreteId', params: { id: freteId} })
          },
          () => {}
        )
      })
    },
    PusherAdministradorLigarEventoEmbarcadorSelecionou() {
      const vm = this
      this.channel.bind('embarcador-selecionou', async function (data) {
        const freteId = data.freteId
        vm.$bus.$emit('embarcador-selecionou', freteId)
        confirmar(
          `Carga ${formataNumeroCarga(freteId)}`,
          `O embarcador selecinou transportador que possui pendências no cadastro e esta ação requer uma reposta através do módulo Contratação. Deseja responder agora?`,
          async () => {
            vm.$router.push({ name: 'ParceiroContratacaoPorFreteId', params: { id: freteId} })
          },
          () => {}
        )
      })
    },
    PusherDesinscreverCanais() {
      if (this.name !== null) {
        this.pusher.unsubscribe(this.name)
        this.channel = null
        this.pusher = null
      }
    },
    async Logar() {
      try {
        delete http.defaults.headers.common['Authorization']
        this.dialog.login.logando = true
        if (this.getUsuario.embarcador[0]) {
          this.login.cpf = this.getUsuario.cpf
          this.login.cnpj = this.getUsuario.embarcador[0].cnpj
        }
        let response = await services.Auth.login(this.login)

        if (response) {
          let usuario = response.data.usuario

          http.defaults.headers.common['Authorization'] = `Bearer ${response.data.truckme}`
          localStorage.setItem('truckme-auth', response.data.truckme)

          this.setUsuario(JSON.parse(JSON.stringify(usuario)))
          this.setLoginExpired(false)
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.dialog.login.logando = false
      }
    },
    async ArmazenarCredenciasAcesso() {
      try {
        this.dialog.repom.salvando = true

        const dto = {
          embarcadorId: this.getUsuario.embarcador[0].id,
          cnpj: this.repom.cnpj,
          usuario: this.repom.usuario,
          senha: this.repom.senha,
        }

        let response = await services.EmbarcadorFinanceiro.solicitarMigracaoParaRepom(dto)

        if (response) {
          this.dialog.repom.aberto = false
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.dialog.repom.salvando = false
      }
    },
    async VerificarMeioPagamento() {
      if (this.getUsuario.perfil !== 'G') return

      const response = await services.EmbarcadorFinanceiro.verificarMeioPagamento();

      if (response) {
        const { meioPagamento, repomAcesso } = response.data

        this.dialog.repom.aberto = meioPagamento === 'REPOM' && repomAcesso.cnpj === null
      }
    },
    Sair() {
      this.setLoginExpired(false)
      this.$router.push('/login')
    },
  },
  mounted() {
    this.PusherInscreverCanais()
    this.VerificarMeioPagamento()
  },
  created() {
    this.PusherFabricarInstancia()
  },
  beforeDestroy() {
    this.PusherDesinscreverCanais()
  },
}
</script>

<style scoped>
section {
  margin: 115px 20px 0px 20px;
}

@media screen and (max-width: 768px) {

section {
  margin: 20px 20px 0px 20px;
}

}
</style>



// WEBPACK FOOTER //
// src/components/Template/Default.vue